import { createRoot } from 'react-dom/client'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'

// Add global error handlers
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find root element')

const root = createRoot(rootElement)

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
) 